import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../utils/Utils";
import { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { getResultByStudentAPI } from "../../../api/LMS/master";
import { toast } from "react-toastify";

const StudentTest = () => {
  const logout = useLogout();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  // const item = location?.state[0]
  const [columns, setColumns] = useState([
    {
      name: "Question",
      selector: (row) => row.question,
      wrap: true,
    },
    {
      name: "Selected",
      selector: (row) => row.selectedOption,
      wrap: true,
    },
    {
      name: "Answer",
      selector: (row) => (row.isCorrect ? "Correct" : "InCorrect"), // Mapping boolean to string for sorting
      sortable: true,
      cell: (row) => (
        <div className={`team-status ${row.isCorrect ? "bg-success" : "bg-danger"} text-white`}>
          <Icon size={`lg`} name={row.isCorrect ? "check" : "cross"} />
          {row.status}
        </div>
      ),
    },
  ]);
  console.log(location, "location");

  useEffect(() => {
    const body = {
      id: location?.state?.id || null,
      user_id: location?.state?.userId || null,
    };
    getStudentTests(body);
  }, [location]);

  const getStudentTests = (body) => {
    getResultByStudentAPI(body)
      .then((res) => {
        if (res.data.status == "success") {
          console.log("data<---", res.data);
          setData(res.data.data);
          setIsLoading(false);
        } else if (res.data.status == "failed") {
          toast.success(res.data.message);
          setIsLoading(false);
          setData([]);
        } else if (res.data.status == "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  }; 

  return (
    <>
      <Head title={"Student Test Result"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {`Student Test Result`}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content">
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        size={"xs"}
                        color={`primary`}
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        <Icon className={`me-1`} name={`arrow-left`} />
                        {"Back"}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>{" "}
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {!isLoading && <Block>
          <PreviewAltCard>
            <div className="team">
              <div className="user-card user-card-s2">
                <div className="user-info">
                  <h6>{data?.resultData[0]?.name}</h6>
                  <span className="sub-text">{data?.resultData[0]?.email}</span>
                </div>
              </div>

              <ul className="team-statistics">
                <li>
                  <span>{data?.resultData[0]?.time}</span>
                  <span>Time</span>
                </li>
                <li>
                  <span>{data?.resultData[0]?.correct_answer}</span>
                  <span>Correct</span>
                </li>
                <li>
                  <span>{data?.resultData[0]?.wrong_answer}</span>
                  <span>Wrong</span>
                </li>
                <li>
                  <span>{data?.resultData[0]?.percentage}%</span>
                  <span>Percentage</span>
                </li>
                <li>
                  <span>{data?.resultData[0]?.total_questions}</span>
                  <span>Questions</span>
                </li>
              </ul>
              {/* <div className="team-view">
                        <Link to={`${process.env.PUBLIC_URL}/user-details-regular/${item.id}`}>
                          <Button outline color="light" className="btn-round w-150px">
                            <span>View Profile</span>
                          </Button>
                        </Link>
                      </div> */}
            </div>
          </PreviewAltCard>
          <MyDataTable isLoading={isLoading} columns={columns} data={data?.answerData} title={"Student Test Result"} />
        </Block>}
      </Content>
    </>
  );
};

export default StudentTest;
